export default function RealTaxFreeTravelerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M9.20996 17.5547H46.7912V42.6016C46.7912 44.8178 45.9108 46.9432 44.3437 48.5103C42.7766 50.0774 40.6512 50.9578 38.435 50.9578H17.5662C15.35 50.9578 13.2246 50.0774 11.6575 48.5103C10.0903 46.9432 9.20996 44.8178 9.20996 42.6016V17.5547Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M17.5649 23.8219V15.4656C17.5649 12.6983 18.6643 10.0442 20.6211 8.08741C22.5779 6.13058 25.2319 5.03125 27.9993 5.03125C30.7667 5.03125 33.4207 6.13058 35.3775 8.08741C37.3344 10.0442 38.4337 12.6983 38.4337 15.4656V23.8219" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M19.6431 31.1281C19.6431 31.266 19.6702 31.4026 19.723 31.5299C19.7758 31.6573 19.8531 31.7731 19.9506 31.8706C20.0481 31.9681 20.1639 32.0454 20.2912 32.0982C20.4186 32.151 20.5552 32.1781 20.6931 32.1781C20.831 32.1781 20.9675 32.151 21.0949 32.0982C21.2223 32.0454 21.338 31.9681 21.4355 31.8706C21.533 31.7731 21.6104 31.6573 21.6631 31.5299C21.7159 31.4026 21.7431 31.266 21.7431 31.1281C21.7431 30.9902 21.7159 30.8537 21.6631 30.7263C21.6104 30.5989 21.533 30.4832 21.4355 30.3857C21.338 30.2882 21.2223 30.2108 21.0949 30.1581C20.9675 30.1053 20.831 30.0781 20.6931 30.0781C20.5552 30.0781 20.4186 30.1053 20.2912 30.1581C20.1639 30.2108 20.0481 30.2882 19.9506 30.3857C19.8531 30.4832 19.7758 30.5989 19.723 30.7263C19.6702 30.8537 19.6431 30.9902 19.6431 31.1281Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M34.2568 41.5734C34.2568 41.8519 34.3675 42.119 34.5644 42.3159C34.7613 42.5128 35.0284 42.6234 35.3068 42.6234C35.5853 42.6234 35.8524 42.5128 36.0493 42.3159C36.2462 42.119 36.3568 41.8519 36.3568 41.5734C36.3568 41.295 36.2462 41.0279 36.0493 40.831C35.8524 40.6341 35.5853 40.5234 35.3068 40.5234C35.0284 40.5234 34.7613 40.6341 34.5644 40.831C34.3675 41.0279 34.2568 41.295 34.2568 41.5734Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M34.2557 28L21.7432 44.7125" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
    </svg>
  );
}
